import { render, staticRenderFns } from "./FormEditarEmpresaRelacao.vue?vue&type=template&id=14d200a4"
import script from "./FormEditarEmpresaRelacao.vue?vue&type=script&lang=js"
export * from "./FormEditarEmpresaRelacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports